import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=4c473924&"
import script from "./ReportDetails.vue?vue&type=script&lang=js&"
export * from "./ReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=4c473924&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports